import { c as _c } from "react/compiler-runtime";
import { AnimatePresence, motion } from 'framer-motion';
import { fadeSlideUp } from '../../animations';
import { cn } from '../../utils/cn';
interface TextIconSwapAnimationProps {
  children: React.ReactNode;
  animationKey: string;
  className?: string;
  duration?: number;
}
export const TextIconSwapAnimation = t0 => {
  const $ = _c(12);
  const {
    children,
    animationKey,
    className,
    duration: t1
  } = t0;
  const duration = t1 === undefined ? 0.35 : t1;
  let t2;
  if ($[0] !== className) {
    t2 = cn("flex items-center gap-1", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = duration / 1.75;
  let t4;
  if ($[2] !== t3) {
    t4 = {
      ...fadeSlideUp.animate,
      transition: {
        delay: t3
      }
    };
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== duration) {
    t5 = {
      type: "spring",
      bounce: 0,
      duration
    };
    $[4] = duration;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== animationKey || $[7] !== children || $[8] !== t2 || $[9] !== t4 || $[10] !== t5) {
    t6 = <AnimatePresence mode="popLayout" initial={false}><motion.div className={t2} key={animationKey} {...fadeSlideUp} animate={t4} transition={t5}>{children}</motion.div></AnimatePresence>;
    $[6] = animationKey;
    $[7] = children;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};